import { path } from 'app/utils/path';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const renderPageDetailRout = (
  moduleName: string,
  id: number,
  name: string,
) => {
  const routes = [
    {
      module: 'hashtags',
      pathName: `${path.hashtags.HASHTAG_VIEW_URI}/${id}/${name}`,
    },
    { module: 'sets', pathName: `${path.sets.SETS_WORDS_URI}/${id}/${name}` },
    { module: 'videos', pathName: `${path.videos.VIDEO_VIEW_URI}/${id}` },
    {
      module: 'posts',
      pathName: `${path.posts.INSTAGRAM_POSTS_DETAILS_URI}/${id}`,
    },
    {
      module: 'influencers',
      pathName: `${path.influencers.ANALYZED_INFLUENCER_DETAILS_URI}/${id}`,
    },
    {
      module: 'entities',
      pathName: `${path.entities.ANALYZED_ENTITIES_DETAILS_URI}/${id}`,
    },
    { module: 'news', pathName: `${path.news.NEWS_DETAILS_URI}/${id}` },
    {
      module: 'organizations',
      pathName: `${path.organization.ORGANIZATION_DETAILS_URI}/${id}`,
    },
    {
      module: 'topics',
      pathName: `${path.topics.TOPICS_DETAILS_URI}/${id}`,
    },
    {
      module: 'tweets',
      pathName: `${path.tweets.TWEET_DETAILS_URI}/${id}`,
    },
    { module: 'users', pathName: `${path.users.USER_PROFILE_URI}/${id}` },
    { module: 'REPORTS', pathName: `${path.reports.REPORT_DETAILS_URI}/${id}` },
  ];
  const currentPath = routes.find(
    (ele) => ele?.module === moduleName && ele?.pathName,
  );
  return currentPath?.pathName;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const renderSubMedulePageDetailRout = (
  subModule: string,
  id: number,
  module?: string,
  sub_sub_module?: string,
) => {
  const routes = [
    {
      sub_module: 'SOURCES',
      pathName: `${path.news.SOURCE_DETAILS_URI}/${id}`,
    },
    {
      sub_module: 'INSTAGRAM',
      pathName: `${path.posts.INSTAGRAM_POSTS_DETAILS_URI}/${id}`,
    },
    {
      sub_module: 'TIKTOK',
      pathName: `${path.posts.TIKTOK_POST_DETAILS_URI}/${id}`,
    },
    {
      sub_module: 'TWITTER',
      pathName: `${path.posts.TWITTER_POST_DETAILS_URI}/${id}`,
    },
    {
      sub_module: 'YOUTUBE',
      pathName: `${path.posts.YOUTUBE_POST_DETAILS_URI}/${id}`,
    },
    {
      sub_module: 'LINKEDIN',
      pathName: `${path.posts.LINKEDIN_POST_DETAILS_URI}/${id}`,
    },
    {
      sub_module: 'SOURCE_EDITIONS',
      pathName: `${path.news.SOURCE_EDITIONS_DETAILS_URI}/${id}`,
    },
    {
      sub_module: 'EDITIORS',
      pathName: `${path.news.EDITOR_DETAILS_URI}/${id}`,
    },
    {
      sub_module: 'AUTHORS',
      pathName: `${path.news.AUTHOR_DETAILS_URI}/${id}`,
    },
    {
      sub_module: 'ITEMS',
      pathName: `${path.archive.ARCHIVE_DETAILS_URI}/${id}`,
    },
    {
      sub_module: 'GROUPS',
      pathName: `${
        module === 'INFLUENCERS'
          ? path.influencers.INFLUENCER_GROUP_DETAILS_URI
          : path.entities.ENTITIES_GROUP_DETAILS_URI
      }/${id}`,
    },

    {
      sub_module: 'TEMPLATES',
      pathName: `${path.reports.TEMPLATE_DETAILS_URI}/${sub_sub_module}/${id}`,
    },
    {
      sub_module: 'RELEASE_NOTES',
      pathName: `${path.settings.RELEASE_NOTES_DETAILS_URL}/${id}`,
    },
  ];
  const currentPath = routes.find(
    (ele) => ele?.sub_module === subModule && ele?.pathName,
  );
  return currentPath?.pathName;
};
